import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext-secure';
import TransactionsView from './TransactionsView';
import SettingsView from './settings/SettingsView';
import ForecastView from './ForecastView.jsx';
import BurgerMenu from './BurgerMenu';
import CalmHeader from './CalmHeader';
import { calmTokens as t } from '../shared/tokens';

export default function Dashboard() {
  const [view, setView] = useState('transactions');
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const { user, logout } = useAuth();

  const handleMonthChange = (m, y) => {
    setSelectedMonth(m);
    setSelectedYear(y);
  };

  if (!user) {
    return (
      <div
        className="calm-viewport"
        style={{
          width: '100%',
          background: t.bg,
          color: t.text,
          display: 'grid',
          placeItems: 'center',
          fontFamily: t.fontUi,
        }}
      >
        Chargement…
      </div>
    );
  }

  return (
    <div
      className="calm-viewport"
      style={{
        width: '100%',
        background: t.bg,
        color: t.text,
        position: 'relative',
        // `overflow: hidden` bloquerait tout `position: sticky` descendant ;
        // seul le débordement horizontal du halo doit être rogné.
        overflowX: 'hidden',
      }}
    >
      {/* Halo ambient indigo */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: -260,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 1100,
          height: 700,
          background:
            'radial-gradient(ellipse at center, rgba(124,143,255,0.12), rgba(124,143,255,0) 65%)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />

      <div style={{ position: 'relative', zIndex: 1 }}>
        <CalmHeader
          user={user}
          currentView={view}
          onViewChange={setView}
          onLogout={logout}
          mobileSlot={
            <div className="calm-burger-slot">
              <BurgerMenu currentView={view} onViewChange={setView} />
            </div>
          }
        />

        <main
          style={{
            maxWidth: view === 'recurring' ? 1180 : 980,
            margin: '0 auto',
            padding: '8px 40px calc(80px + env(safe-area-inset-bottom))',
          }}
          className="calm-main"
        >
          {view === 'transactions' ? (
            <TransactionsView
              month={selectedMonth}
              year={selectedYear}
              onMonthChange={handleMonthChange}
            />
          ) : view === 'forecast' ? (
            <ForecastView
              month={selectedMonth}
              year={selectedYear}
              userId={user.id}
              onMonthChange={handleMonthChange}
            />
          ) : (
            <SettingsView userId={user.id} />
          )}
        </main>
      </div>

      <style>{`
        .calm-burger-slot { display: none; }
        @media (max-width: 1024px) {
          .calm-burger-slot { display: block; }
          .calm-main {
            padding: 4px 20px calc(60px + env(safe-area-inset-bottom)) !important;
          }
        }
        /* Paysage mobile : doit suivre la règle ci-dessus, qui pose le même
           padding en !important. */
        @media (orientation: landscape) and (max-height: 520px) {
          .calm-main {
            padding: 2px 16px calc(24px + env(safe-area-inset-bottom)) !important;
          }
        }
      `}</style>
    </div>
  );
}
